(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-adv-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('.rk-advh__progress');
  if (!bar) return;
  function updateProgressBar() {
    var scrollPosition = window.scrollY;
    var windowHeight = window.innerHeight;
    var bodyHeight = document.body.offsetHeight;
    var progress = (scrollPosition / (bodyHeight - windowHeight)) * 100;
    bar.style.width = progress + '%';
  }
  window.addEventListener('scroll', updateProgressBar);
  window.addEventListener('load', updateProgressBar);
  window.addEventListener('resize', updateProgressBar);
  updateProgressBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-floating"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41Float) return; window.__rkC41Float = 1;
  function init(root){
    (root||document).querySelectorAll('[data-rk-c41-float]:not([data-rkv])').forEach(function(cta){
      cta.setAttribute('data-rkv','1');
      var threshold=parseInt(cta.getAttribute('data-threshold')||'500',10);
      var endOffset=parseInt(cta.getAttribute('data-end-offset')||'100',10);
      function check(){
        var atBottom=(window.scrollY+window.innerHeight)>=(document.documentElement.scrollHeight-endOffset);
        cta.classList.toggle('visible', window.scrollY>threshold && !atBottom);
      }
      window.addEventListener('scroll',check,{passive:true}); check();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41HeroCta) return; window.__rkC41HeroCta = 1;
  // scroll al título "12 reasons" sin ensuciar la URL con el hash
  function init(root){
    (root||document).querySelectorAll('.rk-c41-hero__cta[href^="#"]:not([data-rkv-cta])').forEach(function(a){
      a.setAttribute('data-rkv-cta','1');
      a.addEventListener('click', function(e){
        var t=document.querySelector(a.getAttribute('href'));
        if(!t) return;
        e.preventDefault();
        t.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41Pdp) return; window.__rkC41Pdp = 1;
  function init(root){
    (root||document).querySelectorAll('[data-rk-c41-pdp]:not([data-rkv])').forEach(function(sec){
      sec.setAttribute('data-rkv','1');
      var main=sec.querySelector('[data-rk-c41-pdp-main]');
      var thumbs=Array.prototype.slice.call(sec.querySelectorAll('.rk-c41-pdp__th'));
      if(main && thumbs.length){
        var idx=0;
        var prev=sec.querySelector('[data-rk-c41-pdp-prev]');
        var paint=function(k){
          idx=k;
          var full=thumbs[k].getAttribute('data-full');
          if(full) main.src=full;
          thumbs.forEach(function(t,j){ t.classList.toggle('act', j===k); });
          if(prev) prev.hidden = (k===0);
        };
        thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ paint(k); }); });
        var arr=sec.querySelector('[data-rk-c41-pdp-next]');
        if(arr) arr.addEventListener('click', function(){ paint((idx+1)%thumbs.length); });
        if(prev) prev.addEventListener('click', function(){ paint(idx===0 ? 0 : idx-1); });
      }
      sec.querySelectorAll('[data-rk-c41-pdp-acc]').forEach(function(hd){
        hd.addEventListener('click', function(){
          var bd=hd.nextElementSibling;
          if(!bd) return;
          var wasOpen=bd.classList.contains('open');
          sec.querySelectorAll('.rk-c41-pdp__ab.open').forEach(function(x){ x.classList.remove('open'); });
          sec.querySelectorAll('[data-rk-c41-pdp-acc] span').forEach(function(x){ x.textContent='+'; });
          if(!wasOpen){ bd.classList.add('open'); var mark=hd.querySelector('span'); if(mark) mark.textContent='−'; }
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41Snd) return; window.__rkC41Snd = 1;
  function init(root){
    (root||document).querySelectorAll('.rk-c41-res__frame:not([data-rkv-snd])').forEach(function(fr){
      fr.setAttribute('data-rkv-snd','1');
      var v=fr.querySelector('video'); var chip=fr.querySelector('.rk-c41-res__sound');
      if(!v) return;
      fr.style.cursor='pointer';
      fr.addEventListener('click', function(){
        if(!v.getAttribute('src')) return;
        var willUnmute = v.muted;
        document.querySelectorAll('.rk-c41-res__frame video').forEach(function(o){ o.muted=true; });
        document.querySelectorAll('.rk-c41-res__sound').forEach(function(c){ c.textContent='\uD83D\uDD07 Tap for sound'; });
        v.muted = !willUnmute;
        if(chip) chip.textContent = v.muted ? '\uD83D\uDD07 Tap for sound' : '\uD83D\uDD0A Tap to mute';
        if(v.paused){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      });
    });
  }
  init(document);
  // dots del carrusel mobile: siguen el swipe y son clickeables
  function initDots(root){
    (root||document).querySelectorAll('[data-rk-c41-res-row]:not([data-rkv-dots])').forEach(function(row){
      row.setAttribute('data-rkv-dots','1');
      var sec=row.closest('section')||document;
      var dotsWrap=sec.querySelector('[data-rk-c41-res-dots]');
      if(!dotsWrap) return;
      var dots=[].slice.call(dotsWrap.querySelectorAll('button'));
      var cards=[].slice.call(row.querySelectorAll('.rk-c41-res__card'));
      if(!dots.length||!cards.length) return;
      function paint(i){ dots.forEach(function(d,j){ d.classList.toggle('active', j===i); }); }
      var ticking=false;
      row.addEventListener('scroll', function(){
        if(ticking) return; ticking=true;
        requestAnimationFrame(function(){
          ticking=false;
          var step=cards[0].offsetWidth + 16;
          var i=Math.round(row.scrollLeft/step);
          paint(Math.max(0,Math.min(i,dots.length-1)));
        });
      },{passive:true});
      dots.forEach(function(d,i){
        d.addEventListener('click', function(){
          if(cards[i]) row.scrollTo({left:(cards[i].offsetWidth+16)*i, behavior:'smooth'});
        });
      });
    });
  }
  initDots(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); initDots(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41Tst) return; window.__rkC41Tst = 1;
  function init(root){
    (root||document).querySelectorAll('[data-rk-c41-slider]:not([data-rkv])').forEach(function(sec){
      sec.setAttribute('data-rkv','1');
      var slides=sec.querySelectorAll('.rk-c41-tst__slide'), nav=sec.querySelector('.rk-c41-tst__nav');
      if(!slides.length||!nav) return;
      var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval=parseInt(sec.getAttribute('data-interval')||'5000',10);
      var qi=0, dots=[];
      function paint(i){
        qi=i;
        slides.forEach(function(s,j){ s.classList.toggle('act', j===i); });
        dots.forEach(function(d,j){ d.classList.toggle('active', j===i); });
      }
      dots=Array.prototype.slice.call(nav.querySelectorAll('.rk-c41-tst__dot'));
      dots.forEach(function(d,i){ d.addEventListener('click', function(){ paint(i); }); });
      paint(0);
      if(!reduce && slides.length>1){
        var started=false;
        var start=function(){ if(started) return; started=true; paint(0); setInterval(function(){ paint((qi+1)%slides.length); }, interval); };
        if('IntersectionObserver' in window){
          var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ start(); io.disconnect(); } }); },{threshold:.3});
          io.observe(sec);
        } else { start(); }
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-c41-topbar"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__rkC41Top) return; window.__rkC41Top = 1;

  function initTimers(root){
    // Countdown DIARIO con loop (misma lógica que el counter de gifting-eg):
    // cuenta hasta la próxima ocurrencia de la hora objetivo en la zona configurada;
    // al llegar, re-apunta al día siguiente. Global por reloj: todos ven lo mismo.
    (root||document).querySelectorAll('[data-rk-c41-timer]:not([data-rkv])').forEach(function(t){
      t.setAttribute('data-rkv','1');
      var hh=t.querySelector('[data-rk-c41-timer-hh]'), mm=t.querySelector('[data-rk-c41-timer-mm]'), ss=t.querySelector('[data-rk-c41-timer-ss]');
      var H=parseInt(t.getAttribute('data-h')||'10',10), M=parseInt(t.getAttribute('data-m')||'26',10), TZ=parseFloat(t.getAttribute('data-tz')||'-4');
      function remaining(){
        var tzNow = Date.now() + TZ*3600*1000;
        var d = new Date(tzNow);
        var target = new Date(tzNow); target.setUTCHours(H, M, 0, 0);
        if (target.getTime() <= d.getTime()) target.setUTCDate(target.getUTCDate()+1);
        return target.getTime() - d.getTime();
      }
      function tick(){
        var ms = remaining();
        var h = Math.floor(ms/3600000), m = Math.floor(ms/60000%60), s2 = Math.floor(ms/1000%60);
        if(hh) hh.textContent = String(h).padStart(2,'0');
        if(mm) mm.textContent = String(m).padStart(2,'0');
        if(ss) ss.textContent = String(s2).padStart(2,'0');
      }
      tick(); setInterval(tick,1000);
    });
  }
  function initSold(root){
    (root||document).querySelectorAll('[data-rk-c41-sold]:not([data-rkv])').forEach(function(el){
      el.setAttribute('data-rkv','1');
      var KEY='rkC41Sold';
      var base=parseInt(el.getAttribute('data-start')||'650700',10);
      var saved=0;
      try{ saved=parseInt(localStorage.getItem(KEY)||'0',10)||0; }catch(e){}
      // persiste en el navegador (localStorage): refrescos y visitas posteriores retoman donde quedó (si el setting sube por encima, manda el setting)
      var n=Math.max(saved, base);
      function fmt(x){ return (x/1000).toFixed(1)+'K'; }
      function save(){ try{ localStorage.setItem(KEY, String(n)); }catch(e){} }
      el.textContent=fmt(n); save();
      function up(){ n+=Math.floor(Math.random()*80)+20; el.textContent=fmt(n); save(); setTimeout(up,4000+Math.random()*4000); }
      setTimeout(up,3000);
    });
  }
  // ── Gestor global de videos del listicle (v2 anti-congelado iOS):
  //    IO (rootMargin 200px, ratios) + TOPE de reproducción simultánea (los N más
  //    visibles; iOS evicta decoders con 39 <video> y los deja congelados),
  //    watchdog de stalls con re-arranque, recovery de pausas que mete iOS solo,
  //    pausa total con tab oculto y resume en bfcache (pageshow.persisted).
  //    Rewind anti-flash de Safari igual que v1. Aplica a video[data-rk-c41-loop].
  // Tope SOLO en táctiles/iOS (ahí los decoders se saturan y congelan); desktop reproduce TODO lo visible (comportamiento Blissy)
  var MOBILE=/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || matchMedia('(pointer:coarse)').matches;
  var io=null, MAXPLAY=MOBILE?6:Infinity, vis=new Map(), mgrPause=new WeakSet(), nudges=new WeakMap(), lastT=new WeakMap();
  function safePlay(v){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  function mgrStop(v){ if(!v.paused){ mgrPause.add(v); v.pause(); } }
  function reconcile(){
    var vids=[]; vis.forEach(function(r,v){ vids.push([r,v]); });
    vids.sort(function(a,b){ return (b[0]-a[0]) || ((b[1].paused?0:1)-(a[1].paused?0:1)); });
    var quota=MAXPLAY;
    vids.forEach(function(pair){
      var v=pair[1];
      if(document.hidden || quota<=0){ mgrStop(v); return; }
      quota--; if(v.paused) safePlay(v);
    });
  }
  function initVideos(root){
    var vids=(root||document).querySelectorAll('video[data-rk-c41-loop]:not([data-rkv])');
    if(!vids.length) return;
    if(!io && 'IntersectionObserver' in window){
      io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var v=en.target;
          if(!v.currentSrc && !v.getAttribute('src')) return;
          if(en.isIntersecting) vis.set(v, en.intersectionRatio||0.001);
          else { vis.delete(v); mgrStop(v); }
        });
        reconcile();
      },{rootMargin:'200px 200px',threshold:[0,0.25,0.5,0.75]});
    }
    vids.forEach(function(v){
      v.setAttribute('data-rkv','1');
      if(v.getAttribute('src')){
        v.removeAttribute('loop');
        v.addEventListener('timeupdate',function(){
          if(v.duration && v.currentTime>=v.duration-0.18){ v.currentTime=0; safePlay(v); }
        });
        // iOS a veces pausa solo (decoder/memoria): si sigue visible y no fuimos nosotros, re-encolar
        v.addEventListener('pause',function(){
          if(mgrPause.has(v)){ mgrPause.delete(v); return; }
          if(vis.has(v) && !document.hidden) setTimeout(reconcile, 150);
        });
      }
      if(io) io.observe(v); else if(v.getAttribute('src')) safePlay(v);
    });
    if(!window.__rkC41VidWatch){
      window.__rkC41VidWatch=1;
      // watchdog: video "reproduciendo" cuyo currentTime no avanza = congelado → nudge (máx 4 por video)
      setInterval(function(){
        vis.forEach(function(r,v){
          if(v.paused || document.hidden) return;
          var prev=lastT.get(v);
          lastT.set(v, v.currentTime);
          if(prev===undefined || v.currentTime>prev+0.05) return;
          var n=(nudges.get(v)||0); if(n>=4) return;
          nudges.set(v,n+1);
          var t=v.currentTime;
          try{ v.load(); v.currentTime=t; }catch(e){}
          safePlay(v);
        });
      }, 3000);
      document.addEventListener('visibilitychange', reconcile);
      window.addEventListener('pageshow', function(e){ if(e.persisted) reconcile(); });
      // iOS puede negar play() programático hasta el primer gesto: el primer touch/scroll/click re-dispara
      // reconcile DENTRO del contexto del gesto y desbloquea todos los plays pendientes
      ['touchstart','scroll','click'].forEach(function(ev){
        window.addEventListener(ev, function(){ reconcile(); setTimeout(reconcile, 400); }, {passive:true, once:true});
      });
    }
  }
  // ── Aterrizaje certero del "Read More Reviews" del listicle:
  //    la PDP monta las reviews (Judge.me) tarde — si llegamos con su hash,
  //    re-anclamos cuando el widget ya tiene altura real (y reintentamos
  //    mientras el lazy-load de arriba siga empujando el layout).
  (function(){
    if (location.hash !== '#gxl1W6XhWo') return;
    var anchor = function(){
      var w=document.querySelector('.jdgm-rev-widg')||document.getElementById('gxl1W6XhWo');
      if(!w) return false;
      if(w.offsetHeight<400) return false;
      window.scrollTo(0, w.getBoundingClientRect().top + window.scrollY);
      return true;
    };
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(anchor()){
        clearInterval(iv);
        setTimeout(anchor, 1500);
        setTimeout(anchor, 4000);
      } else if(tries>40){ clearInterval(iv); }
    }, 500);
  })();

  function initAll(root){ initTimers(root); initSold(root); initVideos(root); }
  initAll(document);
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-caf-trustbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rk-caf-tb').forEach(function (bar) {
      var track = bar.querySelector('[data-rk-tb-track]');
      var prev = bar.querySelector('[data-rk-tb-prev]');
      var next = bar.querySelector('[data-rk-tb-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector('.rk-caf-tb__item');
        return item ? item.getBoundingClientRect().width : track.clientWidth;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-countdown-banner-gms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-countdown-banner-sh3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily') {
          // cuenta hasta la próxima HH:MM en la zona UTC configurada (igual que el timer diario de GemPages)
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-countdown-banner-v19"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          // resetea a la HH:MM:SS en la hora LOCAL del visitante (comportamiento real del daily
          // de GemPages, verificado en gifting-eg y crafters; en esta familia el reset observado
          // lleva segundos, por eso parts[2])
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), Number(parts[2] || 0)).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), Number(parts[2] || 0));
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-countdown-banner-v8"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          // resetea a la HH:MM en la hora LOCAL del visitante (comportamiento real del daily de GemPages:
          // el timeZone del gp-data no se aplica — verificado empiricamente en gifting-eg con 2 husos)
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily' && this.dataset.utc === 'local') {
          // reset diario a la hora LOCAL del visitante (comportamiento real de GemPages, medido en 8-reasons-gift2)
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          // cuenta hasta la próxima HH:MM en la zona UTC configurada (igual que el timer diario de GemPages)
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), Number(parts[2] || 0));
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-crafters-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily') {
          // GemPages en la práctica resetea a la HORA LOCAL del visitante (verificado
          // contra el original el 28-ago-2026: 10:26 local, no 10:26 UTC-4)
          const parts = (this.dataset.time || '10:26').split(':');
          const target = new Date();
          target.setHours(Number(parts[0]), Number(parts[1] || 0), 0, 0);
          let t = target.getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-crafters-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily') {
          // GemPages en la práctica resetea a la HORA LOCAL del visitante (verificado
          // contra el original el 28-ago-2026: 10:26 local, no 10:26 UTC-4)
          const parts = (this.dataset.time || '10:26').split(':');
          const target = new Date();
          target.setHours(Number(parts[0]), Number(parts[1] || 0), 0, 0);
          let t = target.getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-cw-buybox"] && !Shopify.designMode) return;
  try {
    
  /* rk-cwqty — selector de cantidad del buybox canvas-wood. Vive DENTRO del form ATC
     (rk-atc lee su input[name=quantity]). Calco del sync de GemPages: al cambiar la
     cantidad, actualiza los inputs hidden de los demás forms /cart/add de la MISMA
     variante en la página (sticky bar, CTA suelto). */
  if (!customElements.get('rk-cwqty')) {
    class RkCwQty extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="quantity"]');
        for (const btn of this.querySelectorAll('[data-rk-step]')) {
          btn.addEventListener('click', () => this.#step(parseInt(btn.dataset.rkStep, 10)));
        }
        this.input?.addEventListener('change', () => this.#set(this.#value()));
      }

      #value() {
        return parseInt(this.input?.value || '1', 10) || 1;
      }

      #step(delta) {
        this.#set(this.#value() + delta);
      }

      #set(value) {
        const qty = Math.max(1, Math.round(value) || 1);
        if (this.input) this.input.value = qty;
        const ownForm = this.closest('form');
        const idInput = ownForm?.querySelector('input[name="id"]');
        if (!idInput) return;
        for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
          if (form === ownForm) continue;
          const fid = form.querySelector('input[name="id"]');
          const fqty = form.querySelector('input[name="quantity"]');
          if (fid && fqty && fid.value === idInput.value) fqty.value = qty;
        }
      }
    }
    customElements.define('rk-cwqty', RkCwQty);
  }

  /* Acordeón EXCLUSIVO con la animación medida en el original (gp-accordion):
     500ms cubic-bezier(0.4, 0, 0.2, 1); al abrir un ítem, el que estaba abierto se
     cierra EN SIMULTÁNEO. Elemento propio de la página (no usa rk-accordion). */
  if (!customElements.get('rk-cwacc')) {
    const RK_CWACC_TIMING = { duration: 500, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };
    class RkCwAcc extends HTMLElement {
      connectedCallback() {
        for (const details of this.querySelectorAll('details')) {
          const summary = details.querySelector('summary');
          if (!summary) continue;
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            this.#onClick(details);
          });
        }
      }

      #onClick(details) {
        if (details.dataset.animating) return;
        if (details.open) {
          this.#close(details);
        } else {
          for (const other of this.querySelectorAll('details[open]')) {
            if (other !== details) this.#close(other);
          }
          this.#open(details);
        }
      }

      #open(details) {
        const content = details.querySelector('[data-rk-panel]');
        if (!content) { details.open = true; return; }
        details.dataset.animating = '1';
        details.open = true;
        const anim = content.animate(
          [{ blockSize: '0px' }, { blockSize: `${content.scrollHeight}px` }],
          RK_CWACC_TIMING
        );
        anim.onfinish = () => { delete details.dataset.animating; };
      }

      #close(details) {
        const content = details.querySelector('[data-rk-panel]');
        if (!content) { details.open = false; return; }
        details.dataset.animating = '1';
        const anim = content.animate(
          [{ blockSize: `${content.scrollHeight}px` }, { blockSize: '0px' }],
          RK_CWACC_TIMING
        );
        anim.onfinish = () => {
          details.open = false;
          delete details.dataset.animating;
        };
      }
    }
    customElements.define('rk-cwacc', RkCwAcc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-fbits-buybox"] && !Shopify.designMode) return;
  try {
    
  /* rk-fbqty — selector de cantidad del buybox finishing-bits. Vive DENTRO del form ATC
     (rk-atc lee su input[name=quantity]). Calco del sync de GemPages (isSyncProduct): al
     cambiar la cantidad actualiza los inputs de los demás forms /cart/add de la MISMA
     variante (barra fija, botón suelto); los related (otra variante) quedan en 1. */
  if (!customElements.get('rk-fbqty')) {
    class RkFbQty extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="quantity"]');
        for (const btn of this.querySelectorAll('[data-rk-step]')) {
          btn.addEventListener('click', () => this.#set(this.#value() + parseInt(btn.dataset.rkStep, 10)));
        }
        this.input?.addEventListener('change', () => this.#set(this.#value()));
      }

      #value() {
        return parseInt(this.input?.value || '1', 10) || 1;
      }

      #set(value) {
        const qty = Math.max(1, Math.round(value) || 1);
        if (this.input) this.input.value = qty;
        const ownForm = this.closest('form');
        const idInput = ownForm?.querySelector('input[name="id"]');
        if (!idInput) return;
        for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
          if (form === ownForm) continue;
          const fid = form.querySelector('input[name="id"]');
          const fqty = form.querySelector('input[name="quantity"]');
          if (fid && fqty && fid.value === idInput.value) fqty.value = qty;
        }
      }
    }
    customElements.define('rk-fbqty', RkFbQty);
  }

  /* rk-fbacc — acordeón FAQ calcado del gp-accordion del original (medido con clicks reales):
     EXCLUSIVO (abrir uno cierra el abierto), ícono + → − en el click, alto animado 500ms
     cubic-bezier(0.4,0,0.2,1) = gp-duration-500 de GemPages. */
  if (!customElements.get('rk-fbacc')) {
    class RkFbAcc extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll(':scope > details')];
        for (const item of this.items) {
          item.querySelector('summary')?.addEventListener('click', (event) => {
            event.preventDefault();
            this.#toggle(item);
          });
        }
      }

      #toggle(item) {
        if (item.dataset.state === 'open') {
          this.#close(item);
          return;
        }
        for (const other of this.items) {
          if (other !== item && other.dataset.state === 'open') this.#close(other);
        }
        this.#open(item);
      }

      #open(item) {
        const panel = item.querySelector('[data-rk-panel]');
        /* un <details> cerrado REPORTA el alto completo del panel (::details-content):
           si estaba cerrado se anima desde 0; si se estaba cerrando, desde el alto actual */
        const from = item.open ? panel.getBoundingClientRect().height : 0;
        item.dataset.state = 'open';
        item.open = true;
        this.#animate(panel, from, panel.scrollHeight, null);
      }

      #close(item) {
        const panel = item.querySelector('[data-rk-panel]');
        const from = panel.getBoundingClientRect().height;
        item.dataset.state = 'closed';
        const finish = () => {
          if (item.dataset.state === 'closed') item.open = false;
        };
        this.#animate(panel, from, 0, finish);
        /* respaldo: si el navegador demora el evento finish (pestaña en segundo plano, CPU
           cargada), el ítem igual queda cerrado */
        setTimeout(finish, 650);
      }

      #animate(panel, from, to, done) {
        panel.rkAnim?.cancel();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
          if (done) done();
          return;
        }
        const anim = panel.animate(
          [{ blockSize: `${from}px` }, { blockSize: `${to}px` }],
          { duration: 500, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        panel.rkAnim = anim;
        anim.onfinish = () => {
          panel.rkAnim = null;
          if (done) done();
        };
      }
    }
    customElements.define('rk-fbacc', RkFbAcc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box-gms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box-sh3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily') {
          // cuenta hasta la próxima HH:MM en la zona UTC configurada (igual que el timer diario de GemPages)
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box-v19"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), Number(parts[2] || 0)).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), Number(parts[2] || 0));
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily' && this.dataset.utc === 'local') {
          // reset diario a la hora LOCAL del visitante (comportamiento real de GemPages, medido en 8-reasons-gift2)
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box-v8"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), 0);
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-offer-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-countdown')) {
    class RkCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'evergreen';
        this.hours = Number(this.dataset.hours || 24);
        this.key = 'rk-cd-' + (this.dataset.key || 'sale');
        this.endAt = this.computeEnd();
        this.els = {
          h: this.querySelector('[data-hrs]'),
          m: this.querySelector('[data-min]'),
          s: this.querySelector('[data-sec]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      computeEnd() {
        if (this.mode === 'daily_local') {
          // resetea a la HH:MM en la hora LOCAL del visitante (comportamiento real del daily de GemPages:
          // el timeZone del gp-data no se aplica — verificado empiricamente en gifting-eg con 2 husos)
          const parts = (this.dataset.time || '10:26').split(':');
          const now = new Date();
          let t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1] || 0), 0).getTime();
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        if (this.mode === 'daily') {
          // cuenta hasta la próxima HH:MM en la zona UTC configurada (igual que el timer diario de GemPages)
          const parts = (this.dataset.time || '10:26').split(':');
          const utc = Number(this.dataset.utc || 0);
          const now = new Date();
          let t = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), Number(parts[0]) - utc, Number(parts[1] || 0), Number(parts[2] || 0));
          if (t <= Date.now()) t += 86400000;
          return t;
        }
        let end = 0;
        try { end = Number(localStorage.getItem(this.key) || 0); } catch (e) { /* storage bloqueado */ }
        const now = Date.now();
        if (!end || end < now) {
          end = now + this.hours * 3600 * 1000;
          try { localStorage.setItem(this.key, String(end)); } catch (e) { /* storage bloqueado */ }
        }
        return end;
      }
      tick() {
        let remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.endAt = this.computeEnd();
          remaining = this.endAt - Date.now();
        }
        const d = remaining / 1000;
        const p = (n) => String(Math.floor(n)).padStart(2, '0');
        if (this.els.h) this.els.h.textContent = p(d / 3600);
        if (this.els.m) this.els.m.textContent = p((d % 3600) / 60);
        if (this.els.s) this.els.s.textContent = p(d % 60);
      }
    }
    customElements.define('rk-countdown', RkCountdown);
  }

  // Reveal de la caja de oferta: slide desde el borde al entrar al viewport.
  // Calco 1:1 del gp-animation del original (motor gp-animation-v7): keyframes translate(-50%)+opacity,
  // duración = 1.5 / speed * 1000 ms, easing ease-out, fill forwards. Se dispara una vez ("appear").
  (function () {
    if (window.__rkOfferRevealInit) return;
    window.__rkOfferRevealInit = true;
    function initReveal(root) {
      (root || document).querySelectorAll('.rk-offer[data-reveal]').forEach(function (sec) {
        var box = sec.querySelector('.rk-offer__box');
        if (!box || box.dataset.rkRevealed) return;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window) || !box.animate) return; // queda visible por CSS
        var dir = (sec.getAttribute('data-reveal') || 'slide-left').replace('slide-', '');
        var axis = (dir === 'left' || dir === 'right') ? 'X' : 'Y';
        var sign = (dir === 'left' || dir === 'down') ? '-' : '';
        var speed = parseFloat(sec.getAttribute('data-reveal-speed')) || 1.7;
        var dur = 1.5 / speed * 1000; // fórmula exacta de GemPages
        box.dataset.rkRevealed = '1';
        box.style.opacity = '0'; // preparar (la caja está fuera del viewport inicial)
        var fired = false;
        var run = function () {
          if (fired) return;
          fired = true;
          var anim = box.animate([
            { opacity: 0, transform: 'translate' + axis + '(' + sign + '50%)' },
            { opacity: 1, transform: 'translate' + axis + '(0)' }
          ], { duration: dur, easing: 'ease-out', fill: 'forwards' });
          anim.onfinish = function () { box.style.opacity = ''; box.style.transform = ''; };
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
        }, { threshold: 0.15 });
        io.observe(box);
        // Sin fallback por tiempo: el IntersectionObserver nativo dispara al entrar la caja al viewport
        // (los navegadores sin soporte ya salieron arriba con la caja visible). Un timer corto
        // "rescataría" la caja antes de que el usuario llegue scrolleando y mataría el slide.
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initReveal(document); });
    } else {
      initReveal(document);
    }
    // soporte para el editor de temas (re-render de sección)
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-presell-press"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-rk-presell-press]').forEach(function(sec){
      if (sec.__rkPbInit) return;
      sec.__rkPbInit = true;
      var track = sec.querySelector('[data-rk-presell-press-track]');
      var dots = sec.querySelector('[data-rk-presell-press-dots]');
      var cards = track.querySelectorAll('[data-rk-presell-press-card]');
      var N = cards.length, cur = 0, pauseUntil = 0;
      if (N < 2) return;
      for (var i = 0; i < N; i++){
        var b = document.createElement('button');
        b.className = 'rk-presell-dot' + (i === 0 ? ' rk-presell-dot--on' : '');
        b.setAttribute('aria-label', 'Review ' + (i + 1));
        (function(idx){ b.addEventListener('click', function(){ pauseUntil = Date.now() + 10000; go(idx); }); })(i);
        dots.appendChild(b);
      }
      function go(i){
        cur = (i + N) % N;
        cards.forEach(function(c, j){ c.style.display = (window.innerWidth < 768 ? (j === cur ? 'block' : 'none') : ''); });
        dots.querySelectorAll('.rk-presell-dot').forEach(function(d, j){ d.classList.toggle('rk-presell-dot--on', j === cur); });
      }
      var x0 = null;
      track.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40){ pauseUntil = Date.now() + 10000; go(cur + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
      setInterval(function(){ if (window.innerWidth < 768 && Date.now() > pauseUntil) go(cur + 1); }, 4000);
      window.addEventListener('resize', function(){ go(cur); });
      go(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-presell-sticky"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-rk-presell-sticky]').forEach(function(bar){
      if (bar.__rkPbInit) return;
      bar.__rkPbInit = true;
      function threshold(){
        var hero = document.querySelector('.rk-presell-hero');
        return hero ? hero.offsetTop + hero.offsetHeight : 500;
      }
      function chk(){ bar.classList.toggle('rk-presell-sticky--show', window.scrollY > threshold()); }
      window.addEventListener('scroll', chk, { passive: true });
      chk();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-presell-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-rk-presell-tst]').forEach(function(sec){
      if (sec.__rkPbInit) return;
      sec.__rkPbInit = true;
      var slides = sec.querySelectorAll('[data-rk-presell-tst-slide]');
      var dots = sec.querySelector('[data-rk-presell-tst-dots]');
      var N = slides.length, cur = 0, pauseUntil = 0;
      if (N < 2) return;
      for (var i = 0; i < N; i++){
        var b = document.createElement('button');
        b.className = 'rk-presell-dot' + (i === 0 ? ' rk-presell-dot--on' : '');
        b.setAttribute('aria-label', 'Testimonial ' + (i + 1));
        (function(idx){ b.addEventListener('click', function(){ pauseUntil = Date.now() + 10000; go(idx); }); })(i);
        dots.appendChild(b);
      }
      function go(i){
        cur = (i + N) % N;
        slides.forEach(function(s, j){ s.classList.toggle('rk-presell-tst__slide--on', j === cur); });
        dots.querySelectorAll('.rk-presell-dot').forEach(function(d, j){ d.classList.toggle('rk-presell-dot--on', j === cur); });
      }
      var tr = sec.querySelector('[data-rk-presell-tst-track]'), x0 = null;
      tr.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      tr.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40){ pauseUntil = Date.now() + 10000; go(cur + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
      setInterval(function(){ if (Date.now() > pauseUntil) go(cur + 1); }, 4000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-presell-topbar"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ── countdown daily-loop ── */
  function initTimer(root){
    var t = root.querySelector('[data-rk-presell-timer]');
    if (!t || t.__rkPbInit) return;
    t.__rkPbInit = true;
    var H = parseInt(t.getAttribute('data-h') || '10', 10);
    var M = parseInt(t.getAttribute('data-m') || '26', 10);
    var TZ = parseFloat(t.getAttribute('data-tz') || '-4');
    var hh = t.querySelector('[data-rk-presell-hh]');
    var mm = t.querySelector('[data-rk-presell-mm]');
    var ss = t.querySelector('[data-rk-presell-ss]');
    function remaining(){
      var tzNow = Date.now() + TZ * 3600 * 1000;
      var d = new Date(tzNow);
      var target = new Date(tzNow); target.setUTCHours(H, M, 0, 0);
      if (target.getTime() <= d.getTime()) target.setUTCDate(target.getUTCDate() + 1);
      return target.getTime() - d.getTime();
    }
    function pad(n){ return String(n).padStart(2, '0'); }
    function tick(){
      var r = remaining();
      hh.textContent = pad(Math.floor(r / 3.6e6));
      mm.textContent = pad(Math.floor(r / 6e4) % 60);
      ss.textContent = pad(Math.floor(r / 1e3) % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── gestor GLOBAL de videos v2 (port del c41 anti-congelado): IO + tope en táctiles
     (iOS satura decoders), watchdog de stalls, recovery de pausas de iOS, pausa con tab
     oculto, resume en bfcache y desbloqueo con primer gesto. Anti-flash Safari igual. ── */
  function initVideoManager(){
    if (window.__rkPresellVideoIO) return;
    var MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || matchMedia('(pointer:coarse)').matches;
    var MAXPLAY = MOBILE ? 6 : Infinity;
    var vis = new Map(), mgrPause = new WeakSet(), nudges = new WeakMap(), lastT = new WeakMap();
    function safePlay(v){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    function mgrStop(v){ if (!v.paused){ mgrPause.add(v); v.pause(); } }
    function reconcile(){
      var vids = []; vis.forEach(function(r, v){ vids.push([r, v]); });
      vids.sort(function(a, b){ return (b[0]-a[0]) || ((b[1].paused?0:1)-(a[1].paused?0:1)); });
      var quota = MAXPLAY;
      vids.forEach(function(pair){
        var v = pair[1];
        if (document.hidden || quota <= 0){ mgrStop(v); return; }
        quota--; if (v.paused) safePlay(v);
      });
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting) vis.set(v, e.intersectionRatio || 0.001);
        else { vis.delete(v); mgrStop(v); }
      });
      reconcile();
    }, { rootMargin: '200px 0px', threshold: [0, 0.25, 0.5, 0.75] });
    window.__rkPresellVideoIO = io;
    function scan(){
      document.querySelectorAll('[data-rk-presell-video]').forEach(function(v){
        if (v.__rkPbObserved) return;
        v.__rkPbObserved = true;
        v.addEventListener('timeupdate', function(){
          if (v.duration && v.currentTime > v.duration - 0.18) v.currentTime = 0;
        });
        v.addEventListener('pause', function(){
          if (mgrPause.has(v)){ mgrPause.delete(v); return; }
          if (vis.has(v) && !document.hidden) setTimeout(reconcile, 150);
        });
        io.observe(v);
      });
    }
    window.__rkPresellScanVideos = scan;
    scan();
    setInterval(function(){
      vis.forEach(function(r, v){
        if (v.paused || document.hidden) return;
        var prev = lastT.get(v);
        lastT.set(v, v.currentTime);
        if (prev === undefined || v.currentTime > prev + 0.05) return;
        var n = (nudges.get(v) || 0); if (n >= 4) return;
        nudges.set(v, n + 1);
        var t = v.currentTime;
        try { v.load(); v.currentTime = t; } catch(e){}
        safePlay(v);
      });
    }, 3000);
    document.addEventListener('visibilitychange', reconcile);
    window.addEventListener('pageshow', function(e){ if (e.persisted) reconcile(); });
    ['touchstart','scroll','click'].forEach(function(ev){
      window.addEventListener(ev, function(){ reconcile(); setTimeout(reconcile, 400); }, { passive: true, once: true });
    });
  }

  function boot(root){ initTimer(root || document); initVideoManager(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); if (window.__rkPresellScanVideos) window.__rkPresellScanVideos(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  // Aparición diferida del sticky: fade-in tras un delay (calco del gp-animation del original,
  // motor gp-animation-v7: duración = 1.5 / speed * 1000 ms, delay en segundos, easing ease-in).
  (function () {
    if (window.__rkStickyAppearInit) return;
    window.__rkStickyAppearInit = true;
    function initAppear(root) {
      (root || document).querySelectorAll('.rk-sticky[data-appear-delay]').forEach(function (bar) {
        if (bar.dataset.rkAppeared) return;
        bar.dataset.rkAppeared = '1';
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var delayS = parseFloat(bar.getAttribute('data-appear-delay')) || 0;
        var speed = parseFloat(bar.getAttribute('data-appear-speed')) || 1.5;
        var dur = 1.5 / speed * 1000; // fórmula exacta de GemPages
        if (reduced || !bar.animate) return; // sin animación: queda visible
        bar.style.opacity = '0';
        bar.style.pointerEvents = 'none';
        var show = function () {
          var anim = bar.animate([{ opacity: 0 }, { opacity: 1 }], { duration: dur, easing: 'ease-in', fill: 'forwards' });
          anim.onfinish = function () { bar.style.opacity = ''; bar.style.pointerEvents = ''; };
        };
        setTimeout(show, delayS * 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAppear(document); });
    } else {
      initAppear(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initAppear(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rk-tcarousel')) {
    class RkTCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.rk-tcar__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.n = this.slides.length;
        if (this.n < 2) return;
        // clones al final para el loop infinito (aria-hidden: no duplican contenido para lectores)
        this.slides.forEach((s) => {
          const c = s.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          this.track.appendChild(c);
        });
        this.i = 0;
        this.timer = null;
        this.intervalMs = (parseFloat(this.dataset.interval) || 2) * 1000;
        // playSpeed del original GemPages = 500ms (duración de la transición de deslizamiento)
        this.durMs = parseFloat(this.dataset.speed) || 500;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.initDrag();
        // autoplay solo con el carrusel a la vista (mismo efecto que el runtime de GemPages)
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? this.play() : this.pause()));
        });
        io.observe(this);
        window.addEventListener('resize', () => this.go(this.i, false));
      }
      step() {
        const w = this.slides[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return w + gap;
      }
      go(idx, animate) {
        this.i = idx;
        this.track.style.transition = animate && !this.reduced ? 'transform ' + this.durMs + 'ms cubic-bezier(0.42, 0, 1, 1)' : 'none';
        this.track.style.transform = 'translateX(' + (-idx * this.step()) + 'px)';
        if (idx >= this.n) {
          // tras entrar en los clones, salto invisible al principio
          clearTimeout(this.jumpT);
          this.jumpT = setTimeout(() => {
            this.i = idx % this.n;
            this.track.style.transition = 'none';
            this.track.style.transform = 'translateX(' + (-this.i * this.step()) + 'px)';
          }, animate ? this.durMs + 30 : 0);
        }
      }
      play() {
        if (this.reduced || this.timer) return;
        this.timer = setInterval(() => this.go(this.i + 1, true), this.intervalMs);
      }
      pause() {
        clearInterval(this.timer);
        this.timer = null;
      }
      initDrag() {
        let startX = 0;
        let base = 0;
        let dragging = false;
        this.track.addEventListener('pointerdown', (e) => {
          dragging = true;
          startX = e.clientX;
          base = -this.i * this.step();
          this.pause();
          this.track.style.transition = 'none';
          this.track.setPointerCapture(e.pointerId);
        });
        this.track.addEventListener('pointermove', (e) => {
          if (!dragging) return;
          this.track.style.transform = 'translateX(' + (base + e.clientX - startX) + 'px)';
        });
        const end = (e) => {
          if (!dragging) return;
          dragging = false;
          const dx = e.clientX - startX;
          let next = this.i;
          if (Math.abs(dx) > 40) next = this.i + (dx < 0 ? 1 : -1);
          if (next < 0) next = 0;
          if (next > this.n) next = this.n;
          this.go(next, true);
          this.play();
        };
        this.track.addEventListener('pointerup', end);
        this.track.addEventListener('pointercancel', end);
      }
    }
    customElements.define('rk-tcarousel', RkTCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
